import React, { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import { RadioButtons } from '@eika/radio-button';

import { KategoriWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { VedleggFormData } from './vedlegg';

interface Props {
    index: number;
    control: Control<VedleggFormData>;
    errors: FieldErrors<VedleggFormData>;
}

const Kategori: FC<Props> = ({ index, control, errors }) => {
    const { vedlegg, validationMessage } = useTranslation();

    return (
        <Controller
            name={`vedlegg.${index}.kategori` as const}
            control={control}
            rules={{
                required: `${validationMessage.requiredChoose}`,
            }}
            render={({ field: { onChange, value } }) => (
                <RadioButtons
                    label={vedlegg.radioTitleKategori}
                    options={[
                        { value: KategoriWeb.ANSETTELSESKONTRAKT, label: vedlegg.radioAnsettelseskontrakt },
                        { value: KategoriWeb.LEIEKONTRAKT, label: vedlegg.radioHusleiekontrakt },
                        { value: KategoriWeb.LOENNSLIPPER_OG_SKATTEMELDING, label: vedlegg.radioKontoutskrift },
                        { value: KategoriWeb.ANNET, label: vedlegg.radioAnnet },
                    ]}
                    selectedOption={value}
                    errorMessage={errors.vedlegg?.[index]?.kategori?.message}
                    onChange={(value) => onChange(value as string)}
                />
            )}
        />
    );
};

export default Kategori;
